<div class="container">
  <div class="heading_align">
    <div class="heading">Användarvillkor <span class="font_14 font_normal"> - för Synappx™</span></div>
  </div>

  <div mat-dialog-content>
    @if (!showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>GÄLLANDE: 25/04/2023</b></div>
        <div class="eula_points">
          Följande Synappx™ Användarvillkor, såväl som <a tabindex="-1" class="text_underline" [href]="privacyUrl"
          target="_blank"><b>Synappx Integritetspolicy</b></a> införlivat häri genom referens (kollektivt
          "Avtalet") är mellan Sharp Corporation ("Sharp") och kund. Detta avtal reglerar tillgång till och användning
          av Synappx, liksom alla tjänster tillgängliga via Synappx. I detta avtal avses med "Synappx", Synappx Go, Synappx Admin och Portal och relaterad dokumentation; termen "tjänster" avser Synappx-tjänster,
          specifika programvarutjänster och all relaterad dokumentation som kan vara egendom tillhörande Sharp
          och/eller tredjepartstjänsteleverantörer ("tredjepartstjänsteleverantörer") och som är tillgängliga via
          Synappx-tjänsten.
        </div>
      </div>
    }
    @if (showSCPToU) {
      <div mat-dialog-content>
        <div class="eula_points"><b>GÄLLANDE: Juli 11 2023</b></div>
        <div class="eula_points">
          Följande Synappx™ Användarvillkor, såväl som <a tabindex="-1" class="text_underline" [href]="privacyUrl"
          target="_blank"><b>Synappx Integritetspolicy</b></a> införlivat häri genom referens (kollektivt
          "Avtalet") är mellan Sharp Corporation ("Sharp") och kund. Detta avtal reglerar tillgång till och användning
          av Synappx, liksom alla tjänster tillgängliga via Synappx. I detta avtal avses med "Synappx", Synappx Go, Synappx Cloud Print, Synappx Admin och Portal och relaterad dokumentation; termen "tjänster" avser Synappx-tjänster,
          specifika programvarutjänster och all relaterad dokumentation som kan vara egendom tillhörande Sharp
          och/eller tredjepartstjänsteleverantörer ("tredjepartstjänsteleverantörer") och som är tillgängliga via
          Synappx-tjänsten.
        </div>
      </div>
    }
    <div class="eula_points">
      Användning av tjänsterna är avsedd för organisationer ( ”kunden”) och deras slutanvändare. Termen
      "slutanvändare" och dess variationer betyder alla som har åtkomst till tjänster som tillhandahålls av
      Synappx tjänster och kan inkludera, men är inte begränsat till, kundens anställda, representanter,
      entreprenörer, agenter eller annan person som använder eller får åtkomst till tjänsterna under ett kundkonto
      och godkänts av kunden att använda tjänsterna. Alla hänvisningar till termen "kund" ska också hänvisa till
      kundens auktoriserade administratör(er) och någon av dess slutanvändare, vare sig enskilt eller kollektivt.
    </div>
    <div class="eula_points">
      Innan användningen och innan åtkomst beviljas till kunden måste auktoriserad(e) administratör(erna) för
      kunden godkänna detta avtal på kundens vägnar. Genom att klicka på "Godkänn" representerar du,
      administratören, och garanterar att: 1) du har utsetts av kunden till "administratör" och har rätt till alla
      rättigheter och privilegier som de som ges i administratörsrollen (närmare beskrivs nedan); 2) du har
      behörighet att binda kunden till detta avtal. Om du inte har utsetts till administratör för kunden eller
      inte har den behörighet som listas ovan får du inte klicka på "Godkänn" och kunden får inte använda eller få
      åtkomst till tjänsterna. När man klickar på ”Godkänn” ska kunden ha rätt att använda och få tillgång till
      tjänsterna under de villkor som anges här.
    </div>
    <div class="eula_points">
      Det kan finnas andra specifika programvarutjänster (”specifika programvarutjänster”) tillgängliga inom eller
      genom Synappx Admin Services som tillåter kunden att utföra vissa funktioner eller använda ytterligare
      tjänster och funktioner; dessa specifika programvarutjänster ägs av Sharp och/eller
      tredjepartstjänsteleverantörer. Kunden förstår att användning och/eller åtkomst till dessa specifika
      programvarutjänster kan kräva att kund, administratör(er) och/eller slutanvändare samtycker till ytterligare
      villkor som gäller för användning av och/eller åtkomst till de specifika programvarutjänsterna ("ytterligare
      villkor"). Om kund, administratör(er) och/eller slutanvändare inte samtycker till sådana villkor eller inte
      har behörighet att godkänna sådana ytterligare villkor, får dessa specifika programvarutjänster inte
      användas eller nås av kund, administratör(er) och/eller slutanvändare, i förekommande fall. I händelse av
      inkonsekvens mellan detta avtal och ytterligare villkor, ska de ytterligare villkoren styra men endast för
      den specifika programvarutjänsten.
    </div>

    <div>
      <div class="eula_points">
        <b>A. Definitioner</b> <br />
        Förutom alla definierade villkor som anges ovan gäller följande definitioner för detta avtal:
        <ol>
          <li> <b>Kundkonto:</b> Avser alla konton under eller tilldelade en kund.
          Detta inkluderar alla tillämpliga administratörskonton samt alla tjänster licensierade till och
        information, data, kopplade till kund, administratör(er) och dess slutanvändare.</li>
        <li> <b>Administratör:</b> Den eller de anställda som utsetts av kunden för
        att hantera informationen och uppgifterna som är förknippade med kundkontot, samt tillgång till
      och licenser för tjänster på kundens vägnar.</li>
      <li> <b>Administratörskonto:</b> Detta hänvisar till administratörens
    konto.:</li>
    <li> <b>Kunduppgifter:</b> Alla uppgifter, information lagrad, överförd,
    bearbetad eller åtkomst via tjänsterna av kund, administratör(er) och/eller dess slutanvändare
  eller associerat till ett kundkonto.</li>
  <li> <b>Återförsäljare:</b> Den auktoriserade återförsäljaren av tjänsterna
  till kunden; återförsäljaren kan vara Sharp, dess dotterbolag eller dotterbolagets direkta
  återförsäljarfilialer (vid direktförsäljning till en kund) eller en auktoriserad tredje parts
  återförsäljare av Sharp-produkter och tjänster. Återförsäljaren är också kundens huvudkontakt
  för supportfrågor relaterade till tjänsterna. Återförsäljaren kan tillhandahålla tjänster för
Kunden i enlighet med ett avtal med Kunden och/eller Administratören.</li>
<li> <b>Dokumentation:</b> Alla installations- och användarguider,
hjälpfiler, vanliga frågor relaterade till åtkomst eller användning av tjänsterna.</li>
<li> <b>Immateriella rättigheter:</b> Alla nuvarande eller framtida globala
rättigheter enligt patent, upphovsrätt, handelshemlighet, varumärke, moraliska rättigheter och
andra immateriella rättigheter.</li>
</ol>
</div>
<div class="eula_points">
  <b>B. Kundanvändning och ansvar </b>
  <ol>
    <li> Kunden ansvarar för att ange vilken/vilka person(er) som är behöriga och kommer att ta rollen
      som administratör på kundens vägnar. Administratörskonton kan tilldelas och återtilldelas av
    kunden.</li>
    <li> Kunden är ansvarig för: hantering av åtkomst till administratörskonton och säkerställande av
      åtkomst till och/eller användning av tjänsterna av kund, administratör(er) och att slutanvändare
      följer detta avtal, ytterligare villkor och all tillämplig dokumentation. Sharp och
      återförsäljaren ansvarar inte för den interna hanteringen, administrationen eller användningen
    av tjänsterna på kundens vägnar.</li>
    <li> Kunden förstår och samtycker till att dess administratör(er) och slutanvändare styrs av och
      kommer att följa detta avtal, de ytterligare villkoren, dokumentationen och alla tillämpliga
      lagar, regler och bestämmelser som rör användning av tjänsterna. Kunden är ensam ansvarig för
      alla handlingar eller underlåtenheter från kunden, dess administratör(er) och slutanvändare
      eller deras underlåtenhet att följa villkoren i detta avtal, ytterligare villkor, dokumentation
      eller tillämpliga lagar, regler och bestämmelser som rör användning av tjänsterna. Detta ansvar
      omfattar all verksamhet under ett kundkonto, oavsett om aktiviteterna utförs av kunden, dess
      anställda eller en tredje part (inklusive, men inte begränsat till, kundens entreprenörer,
    representanter eller agenter).</li>
    <li> Kunden är ansvarig för att administratör(er) och slutanvändare följer alla tillämpliga
      anställningsskyldigheter och villkor och policyer från kunden som sådan avser tillgång till och
    användning av tjänsterna.</li>
    <li> Kunden samtycker till att säkra och underhålla alla tillämpliga samtycken från slutanvändare
      för att tillåta administratörer att delta i alla aktiviteter som beskrivs i detta avtal och för
    att tillåta Sharp och/eller tredjepartsleverantörer att tillhandahålla tjänsterna.</li>
    <li> Kunden är ansvarig för och måste förhindra obehörig åtkomst till och/eller användning av
      tjänster av kund, administratör(er) och slutanvändare och eventuella tredje parter. Kunden
      meddelar omedelbart Sharp och återförsäljare om obehörig åtkomst och/eller användning av
      tjänster. Sharp och återförsäljare kommer inte att vara ansvariga för någon obehörig användning
    av eller tillgång till kundkonton.</li>
    <li> Kunden kommer endast att använda tjänsterna för sin egen interna affärsverksamhet och inte för
      drift av ett servicekontor eller timesharing-tjänst. Kunden får inte medvetet använda eller
      tillåta användning av tjänsterna på ett sätt som kan skada, inaktivera, överbelasta, försämra
      eller på annat sätt störa tjänsterna; detta inkluderar, men är inte begränsat till, användning
      av tjänsterna för att överföra virus eller korrupta filer som kan påverka tjänsternas integritet
    och säkerhet på något sätt.</li>
    <li> Kunden kommer inte och kommer att se till att dess administratör(er) eller slutanvändare inte,
      direkt eller indirekt: (a) baklängeskonstruera, dekompilera, demontera eller på annat sätt
      försöka upptäcka källkoden, objektkoden eller den underliggande strukturen, idéerna eller
      algoritmerna för tjänsterna eller programvara, dokumentation eller data relaterade till eller
      tillhandahållna med eller genom tjänsterna; (b) modifiera, översätta eller skapa derivatverk
      baserade på tjänsterna; eller kopiera (med undantag för arkiveringsändamål), hyra, leasa,
      distribuera, sälja, vidaresälja, pantsätta, tilldela eller på annat sätt överföra eller behålla
      rättigheter i eller till tjänsterna; (c) använda eller få åtkomst till tjänsterna för att bygga
      eller stödja och/eller hjälpa en tredje part att bygga eller stödja produkter eller tjänster som
      är konkurrerande mot tjänsterna; eller (d) ta bort eller ändra ägandemeddelanden eller etiketter
    från tjänsterna.</li>
    <li> Kunden kommer inte och kommer att se till att dess administratör(er) eller slutanvändare inte:
      (a) använda tjänsterna för aktiviteter där användning eller felaktig användning av tjänsterna
      kan leda till fysisk skada, personskada eller död; (b) använda tjänsterna eller tillåta
      användning av tjänsterna för olaglig, bedräglig, kränkande eller skadlig verksamhet; (c) använda
      tjänsterna på ett sätt som kan skada, inaktivera, överbelasta, försämra eller på annat sätt
      störa tillhandahållandet av tjänster, inklusive genom att skicka virus eller skadade filer;
      eller (d) använda tjänsterna för att kränka eller missbruka immateriella rättigheter eller
    andras immateriella rättigheter.</li>
    <li> Kunden förstår att kunden är ansvarig för att följa alla tillämpliga vertikala eller
      branschspecifika regler för överensstämmelse, och att Sharp, återförsäljare och/eller
    tredjepartstjänsteleverantörer inte ska ha något ansvar för att kunden inte gör det.</li>
    <li> Kunden ska vara ensam ansvarig för att skaffa och underhålla lämplig utrustning och tillhörande
      tjänster som behövs för att ansluta till, komma åt, tillhandahålla eller på annat sätt använda
      tjänsterna, inklusive, utan begränsning, datorer, datoroperativsystem och webbläsare,
      internetåtkomst , mobila enheter, multifunktionell kringutrustning (”MFP:er”), bildskärmsystem,
      andra elektroniska enheter och tillbehör (tillsammans, ”utrustning”). Kunden ska se till att
      utrustningen uppfyller alla konfigurationer och specifikationer som anges i dokumentationen, om
      någon, för tjänsterna. Dokumentation relaterad till specifika programvarutjänster kan vara
    tillgänglig via de specifika programvarutjänsterna.</li>
    <li> I händelse av att kunden har ett abonnemangsavtal med en återförsäljare eller en
      tredjepartsleverantör beträffande tjänsterna, eller någon del därav, ska kunden se till att den
      följer ett sådant avtal, inklusive betalning av alla tillämpliga avgifter, eftersom
      underlåtenhet att göra så kan leda till avstängning eller uppsägning av kundkontot eller åtkomst
    till och användning av tjänsterna, eller en del därav.</li>
    <li> I händelse av att det finns en giltig stämning, domstolsbeslut eller annan begäran som
      mottagits av kunden relaterad till tjänsterna, ett kundkonto eller kunddata, ska kunden vara
      ansvarig för att svara på sådana förfrågningar via tillgång till sin egen kundinformation. Om
      kunden inte kan få åtkomst till begärda kunddata eller annan begärd information ska kunden
      kontakta Sharp för att få hjälp och Sharp ska göra kommersiellt rimliga ansträngningar för att
      hjälpa kunden i detta avseende. Om kunden inte svarar snabbt, kan Sharp svara på en sådan
      begäran från tredje part, men är inte skyldig att svara. I händelse av en giltig stämning,
      domstolsbeslut eller annan begäran mottagen av Sharp, återförsäljare och/eller en
      tredjepartstjänsteleverantör relaterad till tjänsterna, ett kundkonto eller kunddata, inklusive,
      men inte begränsat till, administratörskonton eller någon annan data inom kundkontot, ska Sharp,
      återförsäljare och/eller en tredjepartstjänsteleverantör följa den stämning, domstolsbeslut
      eller begäran som kan krävas enligt tillämplig lag. Ytterligare information relaterad till
      Sharps användning av eller potentiell nödvändig åtkomst till kundkonton anges i avsnittet <a
      tabindex="-1" class="text_underline" [href]="privacyUrl" target="_blank"><b>Synappx
    Integritetspolicy</b></a>.</li>
    <li> Kunden är ansvarig för eventuella överträdelser av detta avsnitt av kunden, inklusive någon av
      dess administratör(er) eller slutanvändare. Kunden erkänner och förstår att Sharp,
      återförsäljare och tredjepartstjänsteleverantörer inte har något ansvar gentemot kunden eller på
    annat sätt för några åtgärder som vidtagits av en slutanvändare.</li>
  </ol>
</div>
<div class="eula_points">
  <b>C. Administratörsroll</b>
  <ol>
    <li> Alla administratörer måste använda tjänsterna i enlighet med detta avtal, ytterligare villkor,
      dokumentation, i förekommande fall, alla kundanställningsskyldigheter och villkor och policyer
      för kunden, såväl som alla lagar, regler och bestämmelser som är tillämpliga för åtkomst till
    och/eller användning av tjänsterna.</li>
    <li> Administratören förstår att ytterligare administratörskonton kan tilldelas och omfördelas av
    kunden.</li>
    <li> Med hjälp av Synappx-administratörskontot behåller en administratör kontrollen över kundkontot
      genom att hantera kundkontot, inklusive alla licenser (enskilda eller bundna) som är kopplade
    till kundkontot.</li>
    <li> Administratören kan ställa in, bevilja åtkomst, övervaka, begränsa, avbryta och avsluta åtkomst
      till alla kundkonton, inklusive ytterligare administratörskonton, arbetsytelicenser eller
    slutanvändarlicenser.</li>
    <li> Administratörer kan också vara en slutanvändare, i vilket fall alla villkor i detta avtal eller
      ytterligare villkor relaterade till en slutanvändare också ska gälla för administratören i dess
    egenskap som slutanvändare.</li>
  </ol>
</div>
<div class="eula_points">
  <b>D. Slutanvändareanvändning</b>
  <ol>
    <li> Kunden ska se till att slutanvändare använder tjänsterna i enlighet med detta avtal,
      ytterligare villkor, dokumentation, i förekommande fall, alla kundanställningsskyldigheter och
      villkor och policyer, samt alla lagar, regler och förordningar som är tillämpliga på tillgång
    till och/eller användning av tjänsterna.</li>
    <li> Kunden ansvarar för slutanvändarnas tillgång till och användning av tjänsterna.</li>
    <li> En slutanvändare får inte avskilja sin verksamhet i tjänsterna från kunden.</li>
    <li> Kunden representerar och garanterar att: (a) slutanvändare har alla rättigheter och licenser
      för att komma åt och använda tjänsterna; och (b) att lagring, överföring, bearbetning av all
      information som är relaterad till och åtkomst av slutanvändaren till tjänster inte bryter mot
      villkoren i detta avtal, ytterligare villkor, relevant dokumentation, immateriella rättigheter
    eller andras äganderätt, eller alla tillämpliga lagar, regler eller förordningar.</li>
    <li> Kunden erkänner att den ensam ansvarar för arten, kvaliteten och noggrannheten för alla
    slutanvändaraktiviteter i samband med tjänsterna. </li>
  </ol>
</div>
<div class="eula_points">
  <b>E. Återförsäljarens roll</b>
  <ol>
    <li> Återförsäljaren ansvarar för att upprätta ett kundkonto och tillhandahålla licenser för
      tjänster till administratören. När en administratör för kund har skapats har återförsäljaren
    ingen möjlighet att skapa administratörskonton.</li>
    <li> Återförsäljare kan hantera licenser för kundkonton, inklusive köp eller upphävande av en
      licens. En återförsäljare kan inte upphäva någon licens som redan har tillhandahållits till
    administratören om inte annat uttryckligen anges i detta avtal.</li>
    <li> Återförsäljare har tillgång till grundläggande information om kundkonton, samt kundnamn,
      adress, telefonnummer och namn och e-postadresser för alla administratörer. Återförsäljare
    kommer också att ha tillgång till och kunna se alla kundkonto-licenser för tjänster.</li>
    <li> Återförsäljare kan stänga av och/eller annullera en kunds åtkomst till kundkontot.</li>
    <li>Om din återförsäljare inte kan eller längre är auktoriserad att utföra service på ett kundkonto,
      kan Sharp eller dess
      dotterbolag överföra kundkontot till en annan återförsäljare efter eget gottfinnande. En
      återförsäljare kan inte
    överföra ett kundkonto till en annan återförsäljare på egen hand.</li>
    <li> Återförsäljaren kan använda Tjänsterna som Slutanvändare på kundens begäran.</li>
  </ol>
</div>
<div class="eula_points"><b>F. Tjänster</b>
<ol>
  <li> Kunder får endast komma åt och använda tjänsterna i enlighet med villkoren i detta avtal,
    ytterligare villkor, dokumentation och eventuella ytterligare användarvillkor eller
    integritetspolicy som gäller för åtkomst till och/eller användning av tjänsterna. Underlåtenhet
    att kunden följer detta avtal, ytterligare villkor, dokumentation och tillämpliga lagar, regler
    eller förordningar kan leda till att sådant kundkonto eller administratörskonto stängs av eller
  avslutas efter Sharps eget gottfinnande.</li>
  <li> Tjänster eller delar därav kan omfattas av prenumerationsavtal med återförsäljare och/eller
    tredjepartstjänsteleverantörer; kundens underlåtenhet att uppfylla sådana avtal, inklusive, men
    inte begränsat till, betalning av alla tillämpliga avgifter, kan leda till avstängning eller
    upphävande av kundkontot eller åtkomst till och användning av tjänsterna, eller en del därav,
  som ett resultat av sådan underlåtenhet.</li>
  <li> Tillgång till och användning av tjänsterna är också förutsatt att Sharp tar emot alla avgifter
    från återförsäljaren för kundens tillgång till och användning av tjänsterna; i händelse av att
    Sharp eller dess dotterbolag inte har tagit emot några avgifter som är tillämpliga på ditt
    kundkonto från din återförsäljare, och sådant underlåtande inte åtgärdas inom trettio (30) dagar
    efter skriftligt meddelande om detta; kan Sharp, eller dess dotterbolag, efter eget
    gottfinnande, stänga av eller avsluta ditt kundkonto tills Sharp eller dess dotterbolag erhåller
  sådana betalningar.</li>
  <li> Sharp kommer att använda kommersiellt rimliga ansträngningar för att se till att alla
    anläggningar som används för att lagra och bearbeta kunddata uppfyller kommersiellt rimliga
    säkerhetsstandarder. Genom att använda tjänsterna samtycker kunden till Sharps överföring,
  behandling och lagring av kundinformation.</li>
  <li> Kunden förstår att Sharp och/eller tredjepartstjänsteleverantörer kan uppdatera tjänsterna från
  tid till annan med eller utan meddelande till kunden.</li>
  <li> Oaktat vad som anges om det fastställs att kunddata bryter mot eller kan bryta mot detta avtal
    eller försämrar, överbelastar eller kan hota eller orsaka skador på tjänsterna på något sätt kan
    sådana kunduppgifter raderas, helt eller delvis , efter Sharps eget gottfinnande, med eller utan
    meddelande till kunden och utan Sharps ansvar överhuvudtaget. Kunden ska vara ansvarig för att
  säkerhetskopiera kunddata i händelse av en sådan radering.</li>
  <li> Ytterligare villkor relaterade till integritet, bearbetning och lagring av kunddata samt
    tillgång till kundkonton anges i <a tabindex="-1" class="text_underline" [href]="privacyUrl"
    target="_blank"><b>Synappx integritetspolicy</b></a> och tillämplig dokumentation för
  tjänsterna.</li>
</ol>
</div>
<div class="eula_points"><b>G. Support</b>
<ol>
  <li> Kunden ansvarar för att kontakta återförsäljaren för eventuella supportproblem relaterade till
  tjänsterna som inte kan adresseras via dokumentationen för specifika programvarutjänster.</li>
  <li> Såvida inte Sharp eller en Sharp-återförsäljare är återförsäljare för ditt kundkonto, är Sharp
    inte ansvarigt gentemot kunden för frågor relaterade till eller support för tjänsterna utöver
  vad som tillhandahålls via dokumentationen för specifika programvarutjänster.</li>
</ol>
</div>
<div class="eula_points"><b>H. Immateriella rättigheter</b>
<ol>
  <li> Detta avtal ger inte Sharp, återförsäljare eller någon tredjepartstjänsteleverantör någon rätt
    till kunddata eller de immateriella rättigheterna som ingår i något kundkonto,
    administratörskonto, förutom de begränsade rättigheter som uttryckligen anges i detta avtal
    eller ytterligare villkor eller som annars behövs för att tillhandahålla tjänsterna och låta
  kunden använda tjänsterna.</li>
  <li> Om inte annat specifikt anges i detta avtal eller de ytterligare villkoren, finns det inget
    beviljande till kund, administratör(er) eller slutanvändare av: (a) några immateriella
    rättigheter i eller till tjänsterna eller delar därav; (b) några immateriella rättigheter i
    eller till andra kundkonton; eller (c) några rättigheter att använda logotyper, varumärken,
    servicemärken, domännamn eller varumärkesfunktioner för Sharp, återförsäljare,
  tredjepartstjänsteleverantörer, tjänsterna eller någon del av tjänsterna.</li>
  <li> I den utsträckning som Sharp begärs av kund, administratör(er) eller en slutanvändare för vissa
    åtgärder, inklusive, men inte begränsat till, överföra, hosta eller dela filer, använda eller
    bevilja åtkomst till produktfunktioner eller inställningar, ger kunden Sharp tillstånd att
    utföra alla åtgärder som krävs för att Sharp eller återförsäljaren ska tillhandahålla tjänsterna
    och funktionaliteten som är tillgängliga via tjänsterna och som kan beskrivas i dokumentationen.
    Denna behörighet omfattar alla tjänster från tredje parts leverantörer som Sharp använder för
  att tillhandahålla tjänsterna.</li>
</ol>
</div>

<div class="eula_point">
  <div><b>I. Ansvarsfriskrivningar</b></div>
  <div class="eula_point_left">SHARP GÖR KOMMERSIELLT RIMLIGA ANSTRÄNGNINGAR FÖR ATT GÖRA TJÄNSTERNA
    TILLGÄNGLIGA FÖR KUNDENS ANVÄNDNING ÅTKOMST I ENLIGHET MED DETTA AVTAL, YTTERLIGARE VILLKOR OCH
    TILLÄMPLIG DOKUMENTATION. UtAN HINDER SOM TALAR EMOT DETTA, TILLHANDAHÅLLES TJÄNSTERNA "SOM DE ÄR".
    I DEN UTSRÄCKNING SOM FÖRESKRIVS I LAGEN, UTOM VVAD SOM UTTRYCKLIGEN ANGES HÄR, LÄMNAR SHARP INGA
    GARANTIER AV NÅGOT SLAG FÖR EGEN RÄKNING, ÅTERFÖRSÄLJARE ELLER NÅGON TREDJAPARTSTJÄNSTELEVERANTÖR,
    VARKEN UTTRYCKTA, ANTYDDA ELLER ANDRA, INKLUSIVE NÅGRA GARANTIER ATT TJÄNSTEN KOMMER ATT VARA
    OAVBRUTEN, FELFRI, ATT INNEHÅLLET KOMMER ATT VARA SÄKERT ELLER INTE PÅ ANNAT SÄTT FÖRLORAT ELLER
    SKADAT, ATT DEFEKTER KORRIGERAS ELLER SÄLJBARHET, LÄMPLIGHET FÖR EN VISS ANVÄNDNING ELLER
    ICKE-INTRÅNG. SHARP GÖR INGA UTFÄSTELSER OM NÅGOT INNEHÅLL, INKLUSIVE KUNDDATA I ELLER FRÅN ETT
    KUNDKONTO OCH KUNDEN SKALL VARA ENSAM ANSVARIG FÖR ALL KUNDDATA SAMT ÅTKOMST TILL OCH ANVÄNDNING AV
  TJÄNSTERNA.</div>
</div>

<div class="eula_points"><b>J. Avtalstid och uppsägning</b>
<ol>
  <li> Detta avtal kommer att gälla tills kunden inte längre har en giltig prenumeration eller
    tillgång till tjänsterna, eller tills detta avtal sägs upp i enlighet med villkoren i detta
    avtal. Kunden förstår att vissa specifika programvarutjänster kan sägas upp tidigare i enlighet
  med bestämmelserna i tillämpliga ytterligare villkor.</li>
  <li> Återförsäljare kan säga upp ett kundkonto i händelse av att kunden inte betalar några
    prenumerationsavgifter kunden är skyldig återförsäljaren för kundens användning av eller
  tillgång till tjänsterna.</li>
  <li> Sharp kan säga upp detta avtal och din åtkomst och användning av tjänsterna i händelse av att
    Sharp inte tar emot avgifter från återförsäljaren för kundens användning eller åtkomst till
    tjänsterna och sådant fel inte åtgärdas inom trettio (30) dagar från skriftligt meddelande om
    detta; sådant upphävande eller uppsägning kan fortsätta att gälla tills Sharp får sådana
  betalningar.</li>
  <li> Detta avtal och åtkomst och användning av tjänsterna ska automatiskt förnyas såvida inte kunden
  meddelar återförsäljaren om dess avsikt att säga upp tjänsterna.</li>
  <li> Dessutom kan Sharp eller dess dotterbolag säga upp detta avtal om kunden bryter mot något
    väsentligt villkor i detta avtal och inte avhjälper överträdelsen inom trettio (30) dagar efter
    mottagandet av ett skriftligt meddelande om överträdelsen; sådant skriftligt meddelande kan ha
  formen av ett e-postmeddelande eller annat elektroniskt meddelande.</li>
  <li> I händelse av upphävande av detta avtal ska de rättigheter som beviljats kund,
    administratör(er) och slutanvändare upphöra omedelbart, förutom att kundkonto och kunddata under
    ett kundkonto kommer att vara tillgängliga i femton (15) dagar efter gällande slutdatum för
    prenumerationen. Vid utgången eller uppsägning av detta avtal av någon anledning, förutom vad
    som uttryckligen godkänts enligt detta avsnitt påtar sig kunden att omedelbart avsluta all
    tillgång till och användning av tjänsterna. Kunden medger och samtycker till att Sharp och/eller
    tredjepartstjänsteleverantörer inte har någon skyldighet att behålla kunddata efter den trettio
    (30) dagarsperiod som avses här och att efter denna trettio (30) dagarsperiod kan all kunddata
  oåterkalleligas raderas.</li>
  <li> Trots eventuell uppsägning eller upphävande av detta avtal ska kunden fortfarande vara ansvarig
    för eventuella avgifter som kan komma att åläggas återförsäljare i enlighet med ditt avtal med
    din återförsäljare eller som på annat är skyldiga återförsäljare för användning eller tillgång
  till tjänsterna innan gällande datum för uppsägande eller utgången av detta avtal.</li>
  <li> Meddelanden till kunden enligt detta avsnitt kan ha formen av ett e-postmeddelande eller annat
  elektroniskt meddelande och kan riktas till administratören.</li>
  <li> Följande avsnitt i detta avtal skall fortsätta att gälla efter utgången eller uppsägning av
  detta avtal av någon anledning: Avsnitten F (6), H, I, J (6) till J (9), K, L, M, Q och S.</li>
  <li>1 till 9 i denna artikel J (Giltighetstid och uppsägning) tillämpas inte för Synappx Manage.
    Synappx Manage kan avsluta
    din kostnadsfria användning när som helst och av vilken anledning som helst efter Sharps eget
    gottfinnande, utan ansvar
  gentemot dig.</li>
</ol>
</div>
<div class="eula_point">
  <div><b>K. Skadeersättning</b></div>
  <div class="eula_point_left">Kunden ska ersätta, försvara och hålla Sharp, dess återförsäljare,
    tredjepartstjänsteleverantörer och alla dess samarbetspartners, inklusive men inte begränsat till
    moderföretag eller dotterbolag, direktörer, tjänstemän, anställda, agenter och entreprenörer
    (kollektivt, ”Sharp parterna” ) skadefria från och mot alla skulder, skador och kostnader (inklusive
    förlikningskostnader och rimliga advokatarvoden) som härrör från en tredje parts fordran avseende:
    (a) kundens användning av tjänsterna; (b) all kunddata; (c) varje överträdelse eller brott mot detta
    avtal av kund, administratör(er) och/eller en slutanvändare; och (d) alla överträdelser eller
    påstådda överträdelser av tillämpliga lagar, regler eller föreskrifter som är tillämpliga på kund,
    administratör och/eller en slutanvändare med avseende på tjänsterna. Sharp kommer att vidta
    kommersiellt rimliga åtgärder för att meddela kunden om sådant krav eller fordran som omfattas av
  detta avsnitt.</div>
</div>

<div class="eula_point">
  <div><b>L. Ansvarsbegränsning</b></div>
  <div class="eula_point_left">I DEN UTSTRÄCKNING LAGEN MEDGER KAN SHARPS PARTER INTE VARA ANSVARIGA MOT
    KUNDEN, ADMINISTRATÖRER, SLUTANVÄNDARE OCH NÅGON TREDJE PART FÖR DIREKTA, SPECIELLA, OAVSIKTLIGA,
    INDIREKTA, STRAFFBARA ELLER FÖLJDSKADOR, INKLUSIVE MEN INTE BEGRÄNSAT TILL FÖRLUST AV VINST, DATA,
    ANVÄNDNING ELLER ANNAN FÖRLUST TILL FÖLJD AV ELLER I SAMBAND MED DETTA AVTAL, YTTERLIGARE VILLKOR,
    TJÄNSTERNA, KUNDKONTOT ELLER KUNDDATA. DETTA STYCKE SKALL GÄLLA OAVSETT OM TEORIN OM ANSVARSTAGANDE
    BYGGER PÅ AVTAL, FÖRSEELSE, OAKTSAMHET, GARANTIBROTT, STRIKT ANSVAR ELLER ANNAT OCH HURUVIDA SHARPS
    PARTER HAR INFORMERATS OM MÖLJIGHETEN FÖR SÅDANA SKADOR. UNDER INGA OMSTÄNDIGHETER SKALL SHARPS
    PARTERS ACKUMULATIVA ANSVAR GENTEMOT KUNDEN ELLER TREDJE PART VARA STÖRRE ÄN ETT BELOPP MOTSVARANDE
    TRE MÅNADER AV DIN TJÄNSTEAVGIFT. DU LÖSER HÄRMED SHARPS PARTER FRÅN ALLA SKYLDIGHETER, ANSVAR OCH
    KRAV SOM ÖVERSTIGER DENNA BEGRÄNSNING. DENNA ANSVARSBEGRÄNSNING SKALL FORTSATT GÄLLA ÄVEN EFTER ATT
    DETTA AVTAL UTGÅTT ELLER AVSLUTATS AV NÅGON ANLEDNING OCH GÄLLA ÄVEN OM NÅGON BEGRÄNSAD ÅTGÄRD
  ANGIVEN I DETTA AVSNITT MISSLYCKATS MED DESS GRUNDLÄGGANDE SYFTE.</div>
</div>

<div class="eula_point list_custom">
  <div><b>M. Gällande lag/Avstående från juryförfarande</b></div>
  <div class="eula_point_left">Om Kunden endast använder Tjänsterna för personliga icke-affärsmässiga
    ändamål, kommer detta Avtal att regleras av
  lagarna i den jurisdiktion där Kunden köpte eller erhöll licensen att använda Tjänsterna.</div>
  <div class="eula_point_left">Om kunden inte är en sådan konsument kommer detta avtal att styras av och
    tolkas i enlighet med gällande materiella
  lagar i:</div>
  <ol>
    <li>staten New York, om en licens att använda tjänsterna köps eller erhålls när kunden befinner sig
      i USA, Kanada eller
    Mexiko;</li>
    <li>England och Wales, om en licens att använda tjänsterna köps eller erhålls när kunden befinner
      sig i Storbritannien eller
    i något EES-land;</li>
    <li>det EU-land som kunden befinner sig i, om en licens att använda tjänsterna köps eller erhålls av
    kunden i det EU-landet;</li>
    <li>
      Japan, om en licens att använda tjänsterna köps eller erhålls när kunden befinner sig i någon
      jurisdiktion som inte
      beskrivs ovan;
    </li>
  </ol>
  <div class="eula_point_left">Respektive behöriga domstolar i</div>
  <ol>
    <li>
      New York County, New York när New Yorks lagstiftning är tillämplig;
    </li>
    <li>England och Wales, när lagen i England och Wales är tillämplig.</li>
    <li>kundens EU-land när lagen i det landet i Europeiska unionen är tillämplig;</li>
    <li>Osaka tingsrätt i Japan, när japansk lag gäller</li>
    ska var och en ha icke-exklusiv jurisdiktion över alla tvister som rör
    detta avtal.
  </ol>
  <div class="eula_point_left">
    Eventuella fordringar enligt detta avtal mot Sharps parter måste väckas inom ett (1) år efter det
    att talan har uppstått
    eller så kommer fordran eller talan att preskriberas. Kunden och Sharp skall avstå från
    juryförfarande med avseende på
    eventuella tvister som rör detta avtal eller tjänsterna.
  </div>
</div>

<div class="eula_point">
  <div><b>N. Varumärken</b></div>
  <div class="eula_point_left">Varumärkena eller tjänstevarumärkena "SHARP", "Synappx", "Synappx Meeting",
    "Synappx Go" eller andra relaterade produktnamn, tjänstenamn eller logotyper som används, citeras
    och/eller hänvisas till eller via tjänsterna är varumärken, registrerade varumärken eller
    tjänstevarumärken för Sharp och/eller dess samarbetsenheter. Alla andra produktnamn, tjänstenamn,
    logotyper och/eller företagsnamn som visas på eller genom tjänsterna tillhör respektive innehavare
    och kan skyddas som deras varumärken, registrerade varumärken, tjänstevarumärken och/eller
  handelsnamn.</div>
</div>

<div class="eula_point">
  <div><b>O. Force Majeure</b></div>
  <div class="eula_point_left">Sharps parter, tjänsteleverantörer från tredje part och kunden ansvarar
    inte för otillräcklig prestanda i den utsträckning som orsakats av en omständighet utanför den
    partens rimliga kontroll, inklusive, men inte begränsat till, naturkatastrof, krigshandling,
    terrorism eller fientlighet, upplopp, statliga åtgärder, arbetsförhållanden eller elektriska,
    telekommunikations- eller internetstörningar eller fel. Sharp och kunden samtycker till att använda
  rimliga ansträngningar för att mildra effekterna av varje force majeure-händelse.</div>
</div>

<div class="eula_point">
  <div><b>P. Export</b></div>
  <div class="eula_point_left">Kunden samtycker till att lokala (till det land där användningen av
    tjänsterna används) exportkontrolllagar reglerar din användning av tjänsterna (inklusive teknisk
    data) och eventuella leveranser från åtkomst till och användning av tjänsterna, och kunden samtycker
    till att följa alla sådana exportlagar och förordningar (inklusive regler för ”bedömd export” och
    ”bedömd återexport”). Kunden samtycker till att ingen data, information, programvara och/eller
    material som härrör från tjänsterna (eller direkt produkt därav) kommer att exporteras, direkt eller
    indirekt, i strid med dessa lagar, eller kommer att användas för något syfte som är förbjudet enligt
    dessa lagar, inklusive, utan begränsning, spridning av nukleära, kemiska eller biologiska vapen
  eller utveckling av missilteknologi.</div>
</div>

<div class="eula_point">
  <div><b>Q. Statistisk information</b></div>
  <div class="eula_point_left">Oaktat något annat i detta avtal eller på annat sätt, kan Sharp övervaka
    kundens användning av tjänsterna och använda kunddata på ett aggregerat och anonymt sätt
    sammanställa statistik, användning och prestandainformation i samband med tillhandahållande och
    drift av tjänsterna, och kan göra denna information offentligt tillgänglig (”aggregerad data”),
    under förutsättning att sådan aggregerad data inte identifierar kunden eller avslöjar kunddata.
  Sharp behåller alla immateriella rättigheter i sådana aggregerade data.</div>
</div>

<div class="eula_points"><b>R. Villkorsändring</b>
<ol>
  <li> Sharp kan revidera eller ändra villkoren i detta avtal från tid till annan efter eget
    gottfinnande. händelse av att dessa villkor revideras eller ändras, måste administratör(er)
    acceptera de reviderade eller ändrade villkoren vid den första inloggningen efter
    ikraftträdandet av sådan revision eller ändrring. Den aktuella versionen av detta avtal kommer
    att publiceras på <a tabindex="-1" class="text_underline" [href]="termsUseUrl"
  target="_blank">Synappx supportwebbplats</a> och kunden ansvarar för att kontrollera
  webbplatsen regelbundet. Sharp kommer att göra rimliga ansträngningar för att tillhandahålla
  trettio (30) dagars varsel före det datum då ändringen träder i kraft, men vissa ändringar kan
träda i kraft med mindre än trettio (30) dagars varsel.</li>
<li> Om kunden fortsätter att använda tjänsterna efter ikraftträdandet av det reviderade eller
  ändrade avtalet, samtycker kunden till att den, dess administratör(er) och dess slutanvändare
  därefter kommer att vara bundna av de nya villkoren. Om kunden inte samtycker till de reviderade
avtalsvillkoren kan Kunden välja att upphöra med åtkomst till och användning av tjänsterna.</li>
</ol>
</div>
<div class="eula_points"><b>S. Ytterligare villkor</b>
<ol>
  <li> Kunden samtycker till att det inte finns något partnerskap, joint venture eller agentrelation
  mellan Sharp och kunden.</li>
  <li> Såvida inte kunden specifikt informerar Sharp skriftligen, kan Sharp inkludera kundens namn i
  en lista över kunder på Sharps marknadsföringsmaterial, inklusive webbplatser.</li>
  <li> Om inte annat anges i detta avtal ska allmänna meddelanden från Sharp till kunder eller
    slutanvändare som rör detta avtal eller tjänsterna publiceras på <a tabindex="-1"
  class="text_underline" [href]="supportType" target="_blank">Synappx supportwebbplats</a>.
  Kunder och slutanvändare bör därför regelbundet besöka <a tabindex="-1" class="text_underline"
[href]="supportType" target="_blank">Synappx supportwebbplats</a> för att vara medveten om
sådana meddelanden. Specifika meddelanden om tjänster kommer att gå till administratörens
registrerade e-postadress. Alla meddelanden inklusive juridiska meddelanden, frågor eller
kommentarer relaterade till detta avtal bör riktas till: <br>
<span>Synappx Product Manager</span>
<div>Sharp Corporation </div>
<div>492 Minosho-cho, Yamato-Koriyama City, </div>
<div>Nara 639-1186, Japan</div>
</li>
<li> Kunden får inte tilldela eller överföra någon del av detta avtal utan föregående skriftligt
  medgivande från Sharp. Sharp kan tilldela detta avtal efter att ha meddelat kunden, vilket kan
  ha formen av ett e-postmeddelande, publicering eller meddelande via tjänsterna. Oaktat vad som
  anges kan Sharp överlåta detta avtal till en anknuten enhet eller i samband med en fusion,
  förvärv, omorganisation eller försäljning av alla eller i huvudsak alla dess tillgångar utan att
meddela kunden.</li>
<li> Sharps avstående från överträdelser eller rättigheter enligt detta avtal ska inte betraktas som
ett avstående från något annat eller efterföljande överträdelse eller rättighet.</li>
<li> Om någon bestämmelse i detta avtal (eller en del av detta) befinnes inte kan verkställas eller
  strider mot lag, kommer den att ändras i minsta möjliga utsträckning som krävs för att göra den
  verkställbar, och de återstående delarna av detta avtal kommer att kvarstå i full kraft och
verkan.</li>
<li> Detta avtal och eventuella ytterligare villkor utgör hela avtalet mellan kund och Sharp med
  avseende på tjänsterna och efterträder och ersätter alla tidigare eller samtida överenskommelser
  och avtal, inklusive inköpsorder, antingen skriftliga eller muntliga, med avseende på ämnet för
detta avtal.</li>
</ol>
</div>
</div>
</div>
<div mat-dialog-actions>
  <button mat-button class="primary_btn" (click)="agreeClick()" id="eula-id-agree-button"
  name="eula-name-agree-button">{{"Agree" |translate}}</button>
  <button #eulaCancelButton mat-button (click)="onCancel()" class="secondary_btn" id="eula-id-cancel-button"
  name="eula-name-cancel-button">{{"Decline" |translate}}</button>
</div>
</div>
